import { render } from "./Info.vue?vue&type=template&id=6c1e9c60&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=6c1e9c60&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c1e9c60"

export default script